import React from 'react';
import { Platform } from 'react-native';
import { Dialog, Portal } from 'react-native-paper';
import { Trans } from '@lingui/macro';
import styled, { useTheme } from 'styled-components/native';

import Button from '@src/components/Button';
import { Body1, Body4 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

import Context from './Context';

type Props = {
  children?: React.ReactText;
};

const numberOfLines = 3;
const Container = styled.View``;

const Content = styled(Body4)`
  text-align: center;
`;

const ScrollView = styled.ScrollView.attrs({
  contentContainerStyle: {
    paddingVertical: padding,
  },
})``;

const Component: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  const context = React.useContext(Context);
  const [more, setMore] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const handleTextLayout = React.useCallback(
    (e) =>
      setMore(
        Platform.OS === 'ios'
          ? e.nativeEvent.lines.length >= numberOfLines
          : e.nativeEvent.lines.length > numberOfLines
      ),
    []
  );
  const handleShow = React.useCallback(() => {
    context.setPaused(true);
    setVisible(true);
  }, [context]);
  const handleHide = React.useCallback(() => {
    context.setPaused(false);
    setVisible(false);
  }, [context]);

  return (
    <Container>
      <Content>{children}</Content>
      {more && (
        <Button color={theme.colors.primary} onPress={handleShow}>
          <Trans>More</Trans>
        </Button>
      )}
      <Portal>
        <Dialog visible={visible} onDismiss={handleHide}>
          <Dialog.ScrollArea>
            <ScrollView>
              <Body1>{children}</Body1>
            </ScrollView>
          </Dialog.ScrollArea>
        </Dialog>
      </Portal>
    </Container>
  );
};

Component.displayName = 'Content';

export default React.memo(Component);
